import $ from 'jquery';
import noScroll from '../scripts/noScroll';
import breakpoint from '../scripts/breakpoint';

$.addInit(function(context){
	var base = '.b-humburger';
	$(base, context).each(function(){
		var component = $(this);
		var head = component.closest('.b-head');
		var nav = head.find('.b-menu');
		var isActive = false;

		function open() {
				isActive = !isActive;

				component.toggleClass('m-active', isActive);
				nav.toggleClass('m-open', isActive);

				if (isActive) {
					noScroll.on();
				} else {
					noScroll.off();
				}
		}

		function hide() {
			component.removeClass('m-active');
			nav.removeClass('m-open');

			noScroll.off();
		}

		function setHeightMenu() {
			var headerHeight = head.height();
			var delta = Math.min(window.scrollY, 87);

			nav.css({
				height: 'calc(100vh - ' + headerHeight + 'px + ' + delta + 'px)',
			});
		}

		breakpoint(null, 'lg')
			.onmatch(function(){
				component.on('click', open);
				$(window).on('scroll', setHeightMenu);

			})
			.onmismatch(function() {
				component.off('click', open);
				$(window).off('scroll', setHeightMenu);
				nav.css({
					height: '',
				});

				hide();
			});

	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-humburger.js
// module id = 40
// module chunks = 0